import { React, useState, useEffect, useRef } from "react";
import { useAuth } from "../../AuthContext/AuthContext";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useParams } from "react-router-dom";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../api_Routes";
import Rating from "@mui/material/Rating";
import Email from "../../Assets/ContactIcons/email.png";
import Whatsapp from "../../Assets/ContactIcons/whatsaap.svg";
import Instagram from "../../Assets/ContactIcons/instagram.png";
import { useSnackbar } from "notistack";
import Telegram from "../../Assets/ContactIcons/Telegram.svg";
import Panelimg from "../../Assets/provider.jpeg";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";
import Avatar from "@mui/material/Avatar";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import dayjs from "dayjs";
import { Styles } from "./styles";
import Flag from "react-world-flags";
import DataTableColumn from "./data-table-column";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useCenteredSnackbar} from "../../tools/useCenteredSnackbar";

const PanelsDetails = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const location = useLocation();
  const [value, setValue] = useState(0);
  const [description, setdescription] = useState("");
  const [subject, setsubject] = useState("");
  const [Panel, setPanel] = useState({});
  const [ratingPercentages, setRatingPercentages] = useState([]);
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();
  const { showCenteredPopup } = useCenteredSnackbar();
  const { paneluuid } = useParams();
  const { panelid } = useParams();
  const [averageRating, setAverageRating] = useState("2.6");
  const [isLoading, setIsLoading] = useState(true);
  const [isPanelsLoading, setIsPanelsLoading] = useState(false);
  const [limit, setLimit] = useState(50);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [dataTable, setDataTable] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isloadingreting, setisloadingreting] = useState(false);
  const [Review, setReview] = useState([]);
  const baseApi = api_Routes.Providers.getOne(paneluuid);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false, // This will remove the arrows
  };

  const action = key => (
      <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => closeSnackbar(key)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
  );
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    get_Panels(signal);
    return () => {
      controller.abort();
    };
  }, [page, limit]);
  const panelIdRef = useRef(null);
  const calculateDuration = (date) => {
    if (!date) return "Unknown";
    const now = dayjs();
    const registeredDate = dayjs(date);
    const years = now.diff(registeredDate, "year");
    const months = now.diff(registeredDate.add(years, "year"), "month");
    const yearText = years > 0 ? `${years} year${years > 1 ? "s" : ""}` : "";
    const monthText =
      months > 0 ? `${months} month${months > 1 ? "s" : ""}` : "";
    return [yearText, monthText].filter(Boolean).join(" ");
  };
  const duration = calculateDuration(Panel.domain_registered);
  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const get_Panels = async (signal) => {
    setIsPanelsLoading(true);
    let url = `${baseApi}?page=${page + 1}&limit=${limit}`;
    const { response, message } = await Helper.Get({
      url: url,
      hasToken: true,
      signal: signal,
    });
    if (response && response.success) {
      const { data, pagination } = response;
      panelIdRef.current = response.data.panel_details.id;
      setIsLoading(false);
      setPanel({
        id: response.data.panel_details.id,
        name: response.data.panel_details.name,
        email: response.data.panel_details.email,
        logo: response.data.panel_details.logo,
        customLogo: response.data.panel_details.customLogo,
        description: response.data.panel_details.description,
        trust: response.data.panel_details.trust,
        screenShot: response.data.panel_details.screenShot,
        photos: response.data.panel_details.photos,
        url: response.data.panel_details.url,
        visit_url: response.data.panel_details.visit_url ? response.data.panel_details.visit_url : response.data.panel_details.url,
        whatsapp: response.data.panel_details.whatsapp,
        rate: response.data.rate.avg,
        telegram: response.data.panel_details.telegram,
        instagram: response.data.panel_details.instagram,
        tel1: response.data.panel_details.tel1,
        tel2: response.data.panel_details.tel2,
        tel3: response.data.panel_details.tel3,
        domain_registered: response.data.panel_details.domain_registered,
        payment_method: response.data.payment_method,
        count_review: response.data.count_review,
        country_code: response.data.panel_details.country_code,
        country_name: response.data.panel_details.country_name,
        logo_bg_color: response.data.panel_details.logo_bg_color,
      });
      setReview([]);
      response.data.reviews.forEach((ele) => {
        setReview((prev) => [
          ...prev,
          {
            id: ele.id,
            username: ele.user_name,
            rate: ele.rate,
            description: ele.description,
            subject: ele.subject,
            user_photo: ele.user_photo,
            created_at: ele.created_at,
          },
        ]);
      });
      setTotalItems(data.pagination.total);
      setDataTable(
        data.services.map((panel) => ({
          id: panel.id,
          id_service_for_panel: panel.id_service_for_panel,
          avg: panel.services_avg_rating.avg,
          name: panel.name,
          panelUrl: panel.panelUrl,
          rate_per_1000: panel.rate_per_1000,
          rate: panel.rate,
          order_range: `${panel.min_order} / ${panel.max_order}`,
          category: panel.category,
        }))
      );
      setColumns([
        { id: "id_service_for_panel", label: "ID", minWidth: 50 },
        { id: "name", label: "Service", minWidth: 100 },
        // { id: 'panelUrl', label: 'Panel', minWidth: 100 },
        { id: "rate", label: "Rate", minWidth: 50 },
        { id: "order_range", label: "Min & Max", minWidth: 100 }, // New merged column
        { id: "category", label: "Category", minWidth: 200 },
        // { id: 'description', label: 'Description', minWidth: 200 },
      ]);
      const percentages = data.rate.percentage;
      setRatingPercentages([
        { label: "5 Stars", value: percentages.percentage_rate_5 },
        { label: "4 Stars", value: percentages.percentage_rate_4 },
        { label: "3 Stars", value: percentages.percentage_rate_3 },
        { label: "2 Stars", value: percentages.percentage_rate_2 },
        { label: "1 Star", value: percentages.percentage_rate_1 },
      ]);
      setAverageRating(data.rate.avg || 0);
    } else {
      setIsLoading(false);
      showCenteredPopup(message,
          { variant: "error",
            persist: true });
      // enqueueSnackbar(message, { variant: "error",
      //   persist: true,
      //   action, });
    }
    setIsPanelsLoading(false);
  };
  const handleButtonClick = async () => {
    if (!auth) {
      showCenteredPopup("please login first ",
          { variant: "warning",
            persist: true });
      // enqueueSnackbar("please login first ", { variant: "warning",
      //   persist: true,
      //   action, });
      navigate("/login", { state: { from: location } });
    } else {
      await handleAddRating();
    }
  };
  const handleAddRating = async () => {
    // Validate the required fields
    if (!value || !description || !subject) {
      setisloadingreting(false);
      showCenteredPopup("All fields are required",
          { variant: "error",
            persist: true });
      // enqueueSnackbar("All fields are required", {
      //   variant: "error",
      //   persist: true,
      //   action,
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
      return;
    }

    setisloadingreting(true);
    const panelId = panelIdRef.current;
    const { response, message } = await Helper.Post({
      url: api_Routes.Providers.add_rate,
      data: {
        rate: value,
        panel_id: panelId,
        description: description,
        subject: subject,
      },
      hasToken: true,
    });

    if (response) {
      setisloadingreting(false);
      get_Panels();
      setValue(null);
      setsubject("");
      setdescription("");
      showCenteredPopup(message,
          { variant: "success",
            persist: true });
      // enqueueSnackbar(message, {
      //   variant: "success",
      //   persist: true,
      //   action,
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
    } else {
      let errorMessage = "";
      if (typeof message === "string") {
        errorMessage = message;
      } else if (typeof message === "object") {
        errorMessage = Object.values(message).flat().join(", ");
      }
      showCenteredPopup(errorMessage,
          { variant: "error",
            persist: true });
      // enqueueSnackbar(errorMessage, {
      //   variant: "error",
      //   persist: true,
      //   action,
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
      setisloadingreting(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress sx={{ color: "#425460" }} />
        </Box>
      ) : (
        <div>
          <Box
            sx={{
              padding: {
                xs: "30px",
                sm: "30px 30px 30px 40px",
                md: "30px",
                lg: "30px 80px",
              },
              background: "#D2E2EC",
            }}
            className="offer-details-container"
          >
            {/* PanelsDetails Section */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: "50px", md: "30px" },
              }}
            >
              <Box
                sx={{
                  width: { xs: "100%", md: "62%", lg: "50%" },
                  display: "flex",
                  flexDirection: "column",
                  gap: "60px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "30px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <Styles>
                      {(Panel?.logo || Panel?.customLogo) && (
                        <div className="logo-container" style={{background: Panel.logo_bg_color ?? ""}}>
                          {Panel?.logo ? (
                            <img
                              src={Panel?.logo || Panel?.customLogo}
                              alt="panel_logo"
                              className="panel-logo"
                              style={{ objectFit: "contain" }}
                            />
                          ) : (
                            <div className="final-logo-container" style={{background: Panel.logo_bg_color ?? ""}}>
                              <Typography
                                sx={{
                                  fontSize: `${
                                    Panel?.customLogo?.fontSize
                                      ? `${Panel?.customLogo?.fontSize}px`
                                      : "25px"
                                  }`,
                                  color: `${
                                    Panel?.customLogo?.color || "#FFFFFF"
                                  }`,
                                  fontFamily: `${
                                    Panel?.customLogo?.fontFamily || "Mockads"
                                  }`,
                                }}
                                className="final-logo"
                              >
                                {Panel?.customLogo?.logoName || Panel?.name}
                              </Typography>
                            </div>
                          )}
                        </div>
                      )}
                    </Styles>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#474747",
                            fontWeight: "700",
                            lineHeight: "48px",
                            fontSize: { xs: "30px", md: "40px" },
                          }}
                        >
                          {Panel?.name}
                        </Typography>
                        <Box>
                          {Panel.trust === 1 ? (
                            <Box>
                              <svg
                                width="60"
                                height="30"
                                viewBox="0 0 74 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="0.9375"
                                  y="0.492188"
                                  width="72"
                                  height="20"
                                  rx="10"
                                  fill="white"
                                />
                                <rect
                                  x="0.9375"
                                  y="0.492188"
                                  width="72"
                                  height="20"
                                  rx="10"
                                  stroke="white"
                                />
                                <path
                                  d="M25.3378 6.99219H30.8378V7.98219H28.6878V13.9922H27.4978V7.98219H25.3378V6.99219ZM31.8682 8.99219H32.8882L32.9782 9.61219C33.1116 9.44552 33.2682 9.30885 33.4482 9.20219C33.6282 9.08885 33.8216 9.01219 34.0282 8.97219C34.2416 8.93219 34.4549 8.93885 34.6682 8.99219V10.0322C34.4949 9.97219 34.3082 9.95885 34.1082 9.99219C33.9149 10.0189 33.7349 10.0922 33.5682 10.2122C33.4016 10.3255 33.2649 10.4889 33.1582 10.7022C33.0516 10.9089 32.9982 11.1655 32.9982 11.4722V13.9922H31.8682V8.99219ZM39.8396 13.9922H38.7996L38.7296 13.4922C38.563 13.6722 38.363 13.8122 38.1296 13.9122C37.8963 14.0122 37.6496 14.0622 37.3896 14.0622C36.9963 14.0622 36.6563 13.9822 36.3696 13.8222C36.0896 13.6555 35.873 13.4155 35.7196 13.1022C35.5663 12.7822 35.4896 12.3889 35.4896 11.9222V8.99219H36.6196V11.7722C36.6196 12.1855 36.703 12.5022 36.8696 12.7222C37.0363 12.9355 37.293 13.0422 37.6396 13.0422C37.973 13.0422 38.233 12.9355 38.4196 12.7222C38.613 12.5022 38.7096 12.1789 38.7096 11.7522V8.99219H39.8396V13.9922ZM41.8754 12.3822C41.922 12.5689 42.002 12.7122 42.1154 12.8122C42.2354 12.9122 42.3654 12.9822 42.5054 13.0222C42.6454 13.0555 42.7787 13.0722 42.9054 13.0722C43.1654 13.0722 43.3687 13.0222 43.5154 12.9222C43.6687 12.8155 43.7454 12.6822 43.7454 12.5222C43.7454 12.3889 43.6954 12.2855 43.5954 12.2122C43.4954 12.1389 43.3654 12.0822 43.2054 12.0422C43.052 11.9955 42.892 11.9489 42.7254 11.9022C42.5454 11.8555 42.352 11.8022 42.1454 11.7422C41.9454 11.6822 41.7554 11.5989 41.5754 11.4922C41.3954 11.3855 41.2487 11.2489 41.1354 11.0822C41.022 10.9155 40.9654 10.7089 40.9654 10.4622C40.9654 10.1489 41.052 9.87885 41.2254 9.65219C41.3987 9.41885 41.6354 9.23885 41.9354 9.11219C42.2354 8.98552 42.572 8.92219 42.9454 8.92219C43.392 8.92219 43.7787 9.01552 44.1054 9.20219C44.432 9.38885 44.6687 9.66219 44.8154 10.0222L43.8254 10.3422C43.7787 10.2489 43.7087 10.1689 43.6154 10.1022C43.5287 10.0355 43.422 9.98885 43.2954 9.96219C43.1754 9.92885 43.052 9.91219 42.9254 9.91219C42.712 9.91219 42.532 9.95552 42.3854 10.0422C42.2387 10.1289 42.1654 10.2522 42.1654 10.4122C42.1654 10.4922 42.1887 10.5622 42.2354 10.6222C42.2887 10.6822 42.3587 10.7322 42.4454 10.7722C42.532 10.8055 42.6354 10.8389 42.7554 10.8722C42.8754 10.8989 43.002 10.9322 43.1354 10.9722C43.3487 11.0322 43.5587 11.0989 43.7654 11.1722C43.9787 11.2389 44.172 11.3255 44.3454 11.4322C44.5254 11.5389 44.6654 11.6789 44.7654 11.8522C44.872 12.0255 44.932 12.2455 44.9454 12.5122C44.9454 12.7989 44.862 13.0622 44.6954 13.3022C44.5287 13.5355 44.2887 13.7222 43.9754 13.8622C43.6687 13.9955 43.302 14.0622 42.8754 14.0622C42.382 14.0622 41.9587 13.9555 41.6054 13.7422C41.252 13.5289 41.012 13.1855 40.8854 12.7122L41.8754 12.3822ZM46.3289 8.99219V7.59219H47.4789V8.99219H48.6489V9.98219H47.4789V12.2022C47.4789 12.5022 47.5355 12.7122 47.6489 12.8322C47.7622 12.9455 47.9089 13.0089 48.0889 13.0222C48.2755 13.0289 48.4622 13.0189 48.6489 12.9922V13.9522C48.3622 14.0122 48.0789 14.0289 47.7989 14.0022C47.5255 13.9822 47.2789 13.9089 47.0589 13.7822C46.8389 13.6489 46.6622 13.4555 46.5289 13.2022C46.3955 12.9489 46.3289 12.6155 46.3289 12.2022V9.98219H45.6289V8.99219H46.3289ZM51.8621 14.0622C51.3621 14.0622 50.9221 13.9522 50.5421 13.7322C50.1688 13.5122 49.8755 13.2055 49.6621 12.8122C49.4555 12.4189 49.3521 11.9655 49.3521 11.4522C49.3521 10.9655 49.4555 10.5322 49.6621 10.1522C49.8688 9.77219 50.1555 9.47219 50.5221 9.25219C50.8888 9.03219 51.3055 8.92219 51.7721 8.92219C52.2455 8.92219 52.6621 9.02552 53.0221 9.23219C53.3821 9.43885 53.6621 9.72885 53.8621 10.1022C54.0688 10.4689 54.1721 10.8955 54.1721 11.3822C54.1721 11.4622 54.1688 11.5489 54.1621 11.6422C54.1555 11.7289 54.1455 11.8222 54.1321 11.9222H50.5721C50.6055 12.1555 50.6788 12.3589 50.7921 12.5322C50.9121 12.6989 51.0621 12.8289 51.2421 12.9222C51.4221 13.0155 51.6288 13.0622 51.8621 13.0622C52.1421 13.0622 52.3921 13.0055 52.6121 12.8922C52.8388 12.7789 52.9955 12.6289 53.0821 12.4422L54.0721 12.7722C53.8721 13.1722 53.5755 13.4889 53.1821 13.7222C52.7888 13.9489 52.3488 14.0622 51.8621 14.0622ZM52.9421 11.0022C52.9355 10.7955 52.8788 10.6089 52.7721 10.4422C52.6655 10.2755 52.5255 10.1455 52.3521 10.0522C52.1788 9.95219 51.9855 9.90219 51.7721 9.90219C51.5855 9.90219 51.4088 9.94885 51.2421 10.0422C51.0755 10.1355 50.9321 10.2655 50.8121 10.4322C50.6988 10.5922 50.6255 10.7822 50.5921 11.0022H52.9421ZM58.9174 9.73219L58.7874 9.76219V6.79219H59.9174V13.9922H58.8974L58.8174 13.3722C58.644 13.5655 58.424 13.7289 58.1574 13.8622C57.8907 13.9955 57.574 14.0622 57.2074 14.0622C56.7607 14.0622 56.3674 13.9555 56.0274 13.7422C55.694 13.5289 55.434 13.2289 55.2474 12.8422C55.0607 12.4555 54.9674 12.0055 54.9674 11.4922C54.9674 10.9789 55.0607 10.5289 55.2474 10.1422C55.434 9.75552 55.694 9.45552 56.0274 9.24219C56.3674 9.02885 56.7607 8.92219 57.2074 8.92219C57.6007 8.92219 57.944 9.00219 58.2374 9.16219C58.5307 9.31552 58.7574 9.50552 58.9174 9.73219ZM56.1774 11.4922C56.1774 11.9522 56.2974 12.3255 56.5374 12.6122C56.7774 12.8989 57.0907 13.0422 57.4774 13.0422C57.7107 13.0422 57.924 12.9822 58.1174 12.8622C58.3174 12.7422 58.4774 12.5689 58.5974 12.3422C58.724 12.1089 58.7874 11.8255 58.7874 11.4922C58.7874 11.1589 58.724 10.8789 58.5974 10.6522C58.4774 10.4189 58.3174 10.2422 58.1174 10.1222C57.924 10.0022 57.7107 9.94219 57.4774 9.94219C57.0907 9.94219 56.7774 10.0855 56.5374 10.3722C56.2974 10.6589 56.1774 11.0322 56.1774 11.4922Z"
                                  fill="#004571"
                                />
                                <path
                                  d="M16.6729 15.872C16.557 15.872 16.4411 15.8537 16.3307 15.817C13.9657 15.0315 12.4375 13.1506 12.4375 11.0254V7.27204C12.4375 6.88981 12.7097 6.56294 13.0847 6.49476C14.2845 6.27644 15.3296 5.82651 16.1912 5.15742C16.475 4.93705 16.8709 4.93717 17.1544 5.15742C18.0161 5.82651 19.0612 6.27644 20.261 6.49476C20.636 6.56294 20.9082 6.88981 20.9082 7.27204V11.0254C20.9082 13.1506 19.38 15.0315 17.015 15.817C16.9048 15.8537 16.7888 15.872 16.6729 15.872ZM16.6729 5.71796C16.6599 5.71796 16.6468 5.72207 16.6362 5.73041C15.6815 6.47179 14.5304 6.96911 13.2147 7.20846C13.1847 7.2139 13.1628 7.24074 13.1628 7.27204V11.0254C13.1628 12.8327 14.496 14.4432 16.5594 15.1287C16.6327 15.153 16.7133 15.153 16.7864 15.1287C18.8498 14.4434 20.1829 12.8327 20.1829 11.0254V7.27204C20.1829 7.24061 20.1611 7.2139 20.1313 7.20846C18.8155 6.96911 17.6643 6.47179 16.7095 5.73041C16.6989 5.72219 16.686 5.71796 16.6729 5.71796Z"
                                  fill="#004571"
                                />
                                <path
                                  d="M16.0359 12.3316C15.9033 12.3316 15.7782 12.2737 15.6961 12.1745L14.4113 10.6203C14.2633 10.4413 14.2956 10.182 14.4832 10.0411C14.6708 9.90003 14.9428 9.93082 15.0908 10.1097L16.0359 11.2528L18.2656 8.55554C18.4135 8.37667 18.6855 8.34601 18.8734 8.48694C19.061 8.62786 19.0932 8.8873 18.9453 9.06617L16.3757 12.1745C16.2937 12.2737 16.1684 12.3316 16.0359 12.3316Z"
                                  fill="#004571"
                                />
                              </svg>
                            </Box>
                          ) : (
                            <Box></Box>
                          )}
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#474747",
                            lineHeight: "20px",
                            fontSize: { xs: "14px", sm: "18px" },
                            fontWeight: "400",
                          }}
                          className="offer-details-fonts"
                        >
                          {" "}
                          {Panel.rate}{" "}
                        </Typography>
                        <Rating
                          value={Panel.rate}
                          readOnly
                          sx={{ fontSize: { xs: "1.2rem", sm: "1.7rem" } }}
                          className="offer-details-fonts"
                        />
                        <Typography
                          sx={{
                            color: "#474747",
                            lineHeight: "20px",
                            fontSize: { xs: "12px", sm: "18px" },
                            fontWeight: "400",
                          }}
                          className="offer-details-fonts"
                        >
                          {" "}
                          {Panel.count_review} Reviews{" "}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          color: "#474747",
                          fontWeight: "600",
                          lineHeight: "25px",
                          fontSize: { xs: "12px", sm: "20px" },
                        }}
                        className="offer-details-fonts"
                      >
                        {" "}
                        {Panel.url}{" "}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: { xs: "16px", sm: "18px" },
                      lineHeight: "30px",
                      color: "#474747",
                      width: { xs: "100%", sm: "80%" },
                    }}
                    className="offer-details-fonts"
                  >
                    {Panel.description}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "50px",
                  }}
                >
                  {Panel.domain_registered &&
                    Panel.domain_registered !== "0000-00-00" && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", sm: "center" },
                          width: "100%",
                          flexDirection: { xs: "column", sm: "row" },
                          gap: { xs: "12px", sm: "10px" },
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#474747",
                            fontSize: { xs: "24px", sm: "20px" },
                            lineHeight: "25px",
                            fontWeight: "600",
                          }}
                        >
                          Domain Creating Date :{" "}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",

                            gap: "20px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "400",
                              fontSize: { xs: "14px", lg: "15px" },
                              lineHeight: "20px",
                              color: "#474747",
                            }}
                          >
                            {Panel.domain_registered === "0000-00-00"
                              ? "no data yet"
                              : Panel.domain_registered}
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: { xs: "14px", lg: "15px" },
                              lineHeight: "20px",
                              color: "#474747",
                            }}
                          >
                            {Panel.domain_registered !== "0000-00-00" &&
                              duration}
                            {/* ({duration || "Unknown duration"}) */}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  {Panel.country_name ||
                    (Panel.country_code && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", sm: "center" },
                          width: "100%",
                          flexDirection: { xs: "column", sm: "row" },
                          gap: { xs: "12px", sm: "10px" },
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#474747",
                            fontSize: { xs: "24px", sm: "20px" },
                            lineHeight: "25px",
                            fontWeight: "600",
                          }}
                        >
                          Nationality :{" "}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",

                            gap: "20px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "400",
                              fontSize: { xs: "14px", lg: "15px" },
                              lineHeight: "20px",
                              color: "#474747",
                            }}
                          >
                            <Flag
                              code={Panel.country_code}
                              style={{ width: "20px", height: "15px" }}
                            />
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: { xs: "14px", lg: "15px" },
                              lineHeight: "20px",
                              color: "#474747",
                            }}
                          >
                            {Panel.country_name}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  {(Panel.email ||
                    Panel.whatsapp ||
                    Panel.telegram ||
                    Panel.instagram) && (
                    <Box>
                      <Typography
                        sx={{
                          color: "#474747",
                          lineHeight: "25px",
                          fontSize: "20px",
                          fontWeight: "600",
                        }}
                      >
                        Contact info
                      </Typography>
                      <Grid
                        container
                        spacing={2}
                        sx={{
                          marginTop: "5px",
                          justifyContent: "space-between",
                        }}
                      >
                        {Panel.email && (
                          <Grid item xs={5} sm={5} md={5} lg={5}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <img src={Email} alt="Email" />
                              <Typography
                                component="a"
                                href={`mailto:${Panel.email}`}
                                sx={{
                                  lineHeight: "20px",
                                  fontWeight: "400",
                                  fontSize: "18px",
                                  color: "#474747",
                                  textDecoration: "none",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {Panel.email}
                              </Typography>
                            </Box>
                          </Grid>
                        )}
                        {Panel.whatsapp && (
                          <Grid item xs={5} sm={5} md={5} lg={5}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <img src={Whatsapp} alt="WhatsApp" />
                              <Typography
                                component="a"
                                href={`https://wa.me/${Panel.whatsapp}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                  lineHeight: "20px",
                                  fontWeight: "400",
                                  fontSize: "18px",
                                  color: "#474747",
                                  textDecoration: "none",
                                }}
                              >
                                {Panel.whatsapp}
                              </Typography>
                            </Box>
                          </Grid>
                        )}
                        {Panel.telegram && (
                          <Grid item xs={5} sm={5} md={5} lg={5}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "4px",
                                width: "100%",
                              }}
                            >
                              <img src={Telegram} alt="Telegram" />
                              <Typography
                                component="a"
                                href={`https://t.me/${Panel.telegram}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                  lineHeight: "20px",
                                  fontWeight: "400",
                                  fontSize: "18px",
                                  color: "#474747",
                                  textDecoration: "none",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {Panel.telegram}
                              </Typography>
                            </Box>
                          </Grid>
                        )}
                        {Panel.instagram && (
                          <Grid item xs={5} sm={5} md={5} lg={5}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <img
                                src={Instagram}
                                alt="Instagram"
                                style={{ width: "18px", height: "18px" }}
                              />
                              <Typography
                                component="a"
                                href={`https://instagram.com/${Panel.instagram}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                  lineHeight: "20px",
                                  fontWeight: "400",
                                  fontSize: "18px",
                                  color: "#474747",
                                  textDecoration: "none",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {Panel.instagram}
                              </Typography>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </Box>
                  )}

                  {Panel?.payment_method?.length > 0 && (
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          lineHeight: "25px",
                          fontWeight: "600",
                          color: "#474747",
                        }}
                      >
                        Panel Payment Methods
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "400",
                          lineHeight: "18px",
                          fontSize: "14px",
                          color: "#474747",
                          marginTop: "10px",
                        }}
                      >
                        {Panel?.payment_method?.map((item, idx) => {
                          return (
                            <span key={idx}>
                              {item.type}{" "}
                              {idx !== Panel?.payment_method?.length - 1 && "|"}
                            </span>
                          );
                        })}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  flexDirection: "column",
                  width: { xs: "100%", md: "60%" },
                  gap: { xs: "30px", md: 0 },
                }}
              >
                <div
                  className="img-container"
                  style={{
                    height: "350px",
                    width: "100%",
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "center",
                  }}
                >
                  {Panel?.photos && Panel?.photos.length > 0 ? (
                    Panel.photos.length > 1 ? (
                      <Slider
                        {...settings}
                        style={{
                          height: "100%",
                          width: "100%",
                          maxHeight: "300px",
                          position: "relative",
                          paddingBottom: "30px",
                          textAlign: "-webkit-center",
                        }}
                      >
                        {Panel?.photos.map((photo, index) => (
                          <div
                            key={index}
                            style={{ height: "250px", width: "100%" }}
                          >
                            <img
                              src={photo?.photo_url}
                              alt={`Panel ${index + 1}`}
                              style={{
                                height: "100%",
                                maxHeight: "300px",
                                maxWidth: "800px",
                                width: "100%",
                                objectFit: "cover",
                                borderRadius: "15px 15px 0 0",
                              }}
                            />
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      <img
                        src={Panel?.photos[0].photo_url}
                        alt="Panel"
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "contain",
                        }}
                      />
                    )
                  ) : (
                    <img
                      src={Panel?.screenShot || Panelimg}
                      alt="Panel"
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>

                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    sx={{
                      fontWeight: "700",
                      fontSize: { xs: "14px", lg: "20px" },
                      lineHeight: "30px",
                      textAlign: "center",
                      borderRadius: "10px",
                      padding: { xs: "10px 30px", lg: "10px 70px" },
                      background: "#3F78E0",

                      color: "#F1F5FD",
                      boxShadow:
                        "0px 5px 5px #00000040, inset 4px 7px 5px #FFFFFF30",
                      "&:hover": {
                        background: "#2E5DBA", // Optional: Darken background on hover
                      },
                    }}
                    onClick={() => window.open(Panel.visit_url, "_blank")}
                  >
                    Visit Provider Website
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginLeft: "6px" }}
                    >
                      <g clipPath="url(#clip0_179_2758)">
                        <path
                          d="M9.41487 3.61514H6.91015C5.3515 3.61514 4.5716 3.61514 3.97628 3.91848C3.45262 4.18529 3.02718 4.61073 2.76037 5.1344C2.45703 5.72971 2.45703 6.50962 2.45703 8.06826V18.6438C2.45703 20.2024 2.45703 20.9814 2.76037 21.5766C3.02718 22.1003 3.45262 22.5265 3.97628 22.7932C4.57102 23.0963 5.34997 23.0963 6.90557 23.0963H17.4897C19.0452 23.0963 19.8231 23.0963 20.4178 22.7932C20.9415 22.5265 21.3684 22.0999 21.6351 21.5762C21.9382 20.9815 21.9382 20.2034 21.9382 18.6478V16.1388M23.3297 9.18119V2.22363M23.3297 2.22363H16.3722M23.3297 2.22363L13.5891 11.9642"
                          stroke="white"
                          strokeWidth="3.03603"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_179_2758">
                          <rect width="25" height="25" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{ padding: { xs: "30px", sm: "30px 50px", lg: "30px 80px" } }}
          >
            <Typography
              sx={{
                fontSize: "35px",
                lineHeight: "40px",
                fontWeight: "700",
                color: "#474747",
                marginBottom: "20px",
              }}
            >
              Panel Services
            </Typography>
            <Grid container>
              <Grid item xs={12}>
                <Card>
                  <CardContent sx={{ background: "#F8FAFF" }}>
                    {(isLoading || isPanelsLoading) && <LinearProgress />}
                    {dataTable?.length === 0 ? (
                      <Typography sx={{ textAlign: "center" }}>
                        There are no services for this panel yet
                      </Typography>
                    ) : (
                      <TableContainer style={{ background: "#F8FAFF" }}>
                        <Table stickyHeader sx={{ background: "#F8FAFF" }}>
                          <TableHead>
                            <TableRow>
                              {columns.map((column, index) => (
                                <TableCell
                                  key={column.id}
                                  style={{
                                    background: "#F8FAFF",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    color: "#474747",
                                    border: "1px solid #00000080",
                                  }}
                                >
                                  {column.label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {dataTable.map((row) => (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={row.id}
                              >
                                {columns.map((column, index) => {
                                  const value = row[column.id];
                                  return (
                                    <DataTableColumn
                                      row={row}
                                      column={column}
                                      value={value}
                                    />
                                  );
                                })}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                    {dataTable?.length > 0 && (
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <TablePagination
                            rowsPerPageOptions={[ 25, 50,100]}
                          count={totalItems}
                          rowsPerPage={limit}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleLimitChange}
                          sx={{
                            "& .MuiTablePagination-toolbar": {
                              justifyContent: "space-between",
                              width: "100%",
                              padding: 0,
                            },
                            "& .MuiTablePagination-actions": {
                              display: "flex",
                              justifyContent: "flex-end",
                              "& .MuiIconButton-root": {
                                color: "#004571",
                                backgroundColor: "#F1F7FF",
                                margin: "0 4px",
                                borderRadius: "0%",
                                "&:hover": {
                                  backgroundColor: "#357DAB",
                                },
                                "& svg": {
                                  fontSize: "2rem",
                                },
                              },
                            },
                            "& .MuiTablePagination-selectLabel": {
                              color: "#004571",
                              fontWeight: "bold",
                              fontSize: "0.875rem",
                            },
                            "& .MuiInputBase-root": {
                              backgroundColor: "#F1F7FF",
                              borderRadius: "4px",
                              padding: "4px",
                              marginLeft: "8px",
                              "& .MuiSelect-select": {
                                color: "#004571",
                                padding: "4px 8px",
                                fontWeight: "bold",
                              },
                              "&:hover": {
                                backgroundColor: "#E0F3FF",
                              },
                            },
                            "& .Mui-disabled .MuiSvgIcon-root": {
                              color: "#E0F3FF",
                            },
                            "& .MuiTablePagination-displayedRows": {
                              color: "#004571", // Customize text color
                              fontSize: "0.875rem", // Adjust font size
                              fontWeight: "bold", // Make text bold
                              marginRight: "16px", // Add some spacing on the right if needed
                            },
                          }}
                        />
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{ padding: { xs: "30px", sm: "30px 50px", lg: "30px 80px" } }}
          >
            <Typography
              sx={{
                fontSize: { xs: "25px", md: "35px" },
                lineHeight: "40px",
                fontWeight: "700",
                color: "#474747",
                marginBottom: "20px",
                textAlign: { xs: "center", sm: "center", md: "start" },
              }}
            >
              Feedback & Reviews
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "flex-start",
                gap: "60px",
              }}
            >
              <Box
                sx={{
                  background: "#F8FAFF",
                  width: { xs: "100%", md: "50%" },
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "-4px 4px 4px #00000040",
                  border: "1px solid #959595",
                  borderRadius: "25px",
                  maxHeight: "700px",
                  overflow: "hidden", // Ensures rounded corners clip the content
                }}
              >
                {/* Inner scrolling container */}
                <Box
                  sx={{
                    overflow: "auto", // Enables scrolling
                    height: "100%",
                    "&::-webkit-scrollbar": {
                      width: "6px", // Width of the scrollbar
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#B9B9B9",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#3F78E0", // Color of the scrollbar thumb
                      borderRadius: "10px", // Rounded corners for the thumb
                    },
                  }}
                >
                  {Review.length > 0 ? (
                    Review.map((ele) => (
                      <Box
                        key={ele.id}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "30px",
                          gap: "10px",
                          alignItems: { xs: "flex-start", md: "flex-start" },
                          marginBottom: "36px",
                          borderBottom: "1px solid #D9D9D9",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Avatar
                            src={ele.user_photo}
                            alt="person"
                            sx={{
                              border: "1px solid #959595",
                              width: "60px",
                              height: "60px",
                            }}
                          />
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "500",
                                fontSize: "25px",
                                lineHeight: "30px",
                                color: "#474747",
                              }}
                            >
                              {ele.username}
                            </Typography>
                            <Typography
                              sx={{
                                color: "#959595",
                                lineHeight: "25px",
                                fontSize: "20px",
                                fontWeight: "500",
                              }}
                            >
                              {ele.created_at}
                            </Typography>
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "6px",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "20px",
                              lineHeight: "26px",
                              color: "#474747",
                            }}
                          >
                            {ele.subject}
                          </Typography>
                          |
                          <Typography
                            sx={{
                              fontSize: "20px",
                              lineHeight: "26px",
                              color: "#959595",
                              fontWeight: "600",
                            }}
                          >
                            ({ele.rate})
                          </Typography>
                          <Rating
                            value={ele.rate}
                            readOnly
                            sx={{ fontSize: "1.5rem" }}
                          />
                        </Box>
                        <Box sx={{ marginBottom: "20px" }}>
                          <Typography
                            sx={{
                              fontWeight: "400",
                              fontSize: "20px",
                              lineHeight: "26px",
                              color: "#474747",
                            }}
                          >
                            {ele.description}
                          </Typography>
                        </Box>
                      </Box>
                    ))
                  ) : (
                    <Typography sx={{ padding: "20px" }}>
                      No reviews yet
                    </Typography>
                  )}
                </Box>
              </Box>

              <Box sx={{ width: { xs: "100%", md: "50%" } }}>
                {/* Ratings Statistics Header */}
                <Box mb={4}>
                  <Typography
                    sx={{
                      fontWeight: "500",
                      color: "#474747",
                      fontSize: "28px",
                      lineHeight: "35px",
                      textAlign: { xs: "center", md: "normal" },
                    }}
                  >
                    Ratings Statistics
                  </Typography>
                  <Typography
                    sx={{
                      color: "#959595",
                      lineHeight: "30px",
                      fontSize: "24px",
                      fontWeight: "500",
                      marginTop: "10px",
                      textAlign: { xs: "center", md: "start" },
                    }}
                  >
                    {Number.isFinite(averageRating)
                      ? averageRating.toFixed(2)
                      : "0.00"}{" "}
                    out of 5.00
                  </Typography>
                </Box>

                {/* Display Rating Percentages */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  {ratingPercentages.map((item, index) => (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                      mb={1}
                      key={index}
                    >
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "24px",
                          lineHeight: "30px",
                          color: "#474747",
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Box width="100%" mr={1} ml={1}>
                          <LinearProgress
                            variant="determinate"
                            value={item.value}
                            sx={{
                              "& .MuiLinearProgress-bar": {
                                backgroundColor: "#ECA601", // Color of the filled progress
                              },
                              backgroundColor: "#B9B9B9", // Color of the unfilled track
                              height: 10, // Optional: adjust height if desired
                              borderRadius: "5px", // Optional: rounded corners
                            }}
                          />
                        </Box>

                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "20px",
                            lineHeight: "25px",
                            color: "#959595",
                          }}
                        >
                          {`${item.value.toFixed(1)}%`}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{ padding: { xs: "30px", sm: "30px 50px", lg: "30px 80px" } }}
          >
            <Box
              sx={{
                background: "#EBF2FF",
                padding: "50px 10px",
                borderRadius: "25px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "35px",
                  lineHeight: "40px",
                  color: "#474747",
                  textAlign: "center",
                }}
              >
                Add your own review
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-around",
                  alignItems: "center",
                  padding: { xs: "30px 50px", sm: "30px 10px", md: "30px 5px" },
                  gap: { xs: "20px", sm: 0 },
                }}
              >
                <Box sx={{ width: { xs: "100%", sm: "45%" } }}>
                  <Typography
                    sx={{
                      marginBottom: "10px",
                      fontSize: "22px",
                      lineHeight: "25px",
                      fontWeight: "500",
                      color: "#474747",
                    }}
                  >
                    Review description
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={4} // sets the initial height
                    InputLabelProps={{
                      style: { color: "#434343", fontSize: "13px" },
                    }}
                    value={description}
                    onChange={(e) => {
                      setdescription(e.target.value);
                    }}
                    name="description"
                    placeholder="Add Your Comment About The Review.."
                    sx={{
                      background: "white",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none", // removes the outline
                        },
                        "& textarea": {
                          // target textarea styling
                          borderRadius: "10px",
                          padding: "10px",
                        },
                      },
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    width: { xs: "100%", sm: "40%" },
                    display: "flex",
                    flexDirection: "column",
                    gap: "30px",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        marginBottom: "10px",
                        fontSize: "22px",
                        lineHeight: "25px",
                        fontWeight: "500",
                        color: "#474747",
                      }}
                    >
                      Subject Title
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{
                        style: { color: "#434343", fontSize: "13px" },
                      }}
                      name="  Subject Title"
                      value={subject}
                      onChange={(e) => {
                        setsubject(e.target.value);
                      }}
                      placeholder="Add Your Comment About The Review ..."
                      sx={{
                        background: "white",
                        borderRadius: "10px",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            border: "none", // removes the outline
                          },
                          "& input": {
                            borderRadius: "10px",
                            padding: "10px ",
                          },
                        },
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        marginBottom: "10px",
                        fontSize: "22px",
                        lineHeight: "25px",
                        fontWeight: "500",
                        color: "#474747",
                      }}
                    >
                      Your Rating
                    </Typography>
                    <Rating
                      size="large"
                      name="simple-controlled"
                      value={value}
                      onChange={(event, newValue) => {
                        setValue(newValue);
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "30px",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    background: "#ECA601",
                    padding: "5px 50px",
                    borderRadius: "10px",
                    // Adding inner shadow using a pseudo-element
                    color: "#F1F5FD",
                    position: "relative",
                    lineHeight: "38px",
                    overflow: "hidden",
                    fontWeight: "700",
                    fontSize: "28px",
                    boxShadow: "0px 3px 3px #00000040", // Outer shadow
                    "&:before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      borderRadius: "0 20px 20px 0",
                      background: "rgba(255, 255, 255, 0.1)", // Color for the inner shadow
                      filter: "blur(4px)",
                      zIndex: 1,
                    },
                    "&:hover:before": {
                      background: "rgba(255, 255, 255, 0.2)", // Darker on hover for inner shadow
                    },
                  }}
                  onClick={handleButtonClick}
                >
                  {isloadingreting ? (
                    <CircularProgress size={22} sx={{ color: "white" }} />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Box>
            </Box>
          </Box>
        </div>
      )}
    </>
  );
};
export default PanelsDetails;
